export const clearButtonSx = {
  minWidth: 0,
  padding: '2px 8px',
  borderRadius: '6px',
  fontFamily: 'Montserrat, sans-serif',
  textTransform: 'none',

  color: 'var(--main-color)',
  border: '1px solid var(--secondary-color)',
  width: 'fit-content',
  background: 'var(--secondary-color)',
  boxShadow: 'none',

  '&.Mui-disabled': {
    color: 'var(--light-secondary-color)',
    borderColor: 'var(--light-secondary-color)',
  },
};
